// Basemap escuro usado por todos os mapas do app.
//
// A CARTO passou a carimbar "API KEY REQUIRED" em cima de cada tile do
// basemaps.cartocdn.com, entao servimos o Esri Dark Gray Canvas: mesmo visual
// quase-preto, sem chave e sem marca d'agua. Ele vem em duas camadas (base +
// rotulos) e so tem tiles nativos ate o z16, por isso o maxNativeZoom deixa o
// Leaflet ampliar os tiles alem disso em vez de mostrar buracos cinza.
var ESRI = "https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/";
var ATTRIB = "&copy; Esri";
var MAX_NATIVE = 16;

// Adiciona base + rotulos ao mapa e devolve as duas camadas.
export function addDarkBasemap(map, opts) {
  var o = opts || {};
  var common = {
    maxZoom: o.maxZoom || 18,
    maxNativeZoom: MAX_NATIVE,
    attribution: ATTRIB
  };
  if (o.minZoom) common.minZoom = o.minZoom;
  var base = window.L.tileLayer(ESRI + "World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}", common).addTo(map);
  // Adicionada depois da base para os rotulos ficarem por cima dela.
  var labels = window.L.tileLayer(ESRI + "World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}", common).addTo(map);
  return { base: base, labels: labels };
}
